import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import { useSoftRiseShadowStyles } from "@mui-treasury/styles/shadow/softRise";
import { useSlopeCardMediaStyles } from "@mui-treasury/styles/cardMedia/slope";
import { useN01TextInfoContentStyles } from "@mui-treasury/styles/textInfoContent/n01";
import TextInfoContent from "@mui-treasury/components/content/textInfo";
import { useNavigate } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import { animateScroll as scroll } from "react-scroll";
import { useCMS } from "../../utils/useCMS";

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 304,
    margin: "auto",
  },
  content: {
    padding: 24,
  },
  avatar: {
    width: 50,
    height: 50,
    border: "2px solid #fff",
    margin: "-48px 32px 0 auto",
    "& > img": {
      margin: 0,
    },
  },
}));

const ApartmentCardSmall = (props) => {
  const cardStyles = useStyles();
  const mediaStyles = useSlopeCardMediaStyles();
  const shadowStyles = useSoftRiseShadowStyles();
  const textCardContentStyles = useN01TextInfoContentStyles();
  const navigate = useNavigate();
  const { getImageUrl } = useCMS();

  function readClicked(e) {
    e.preventDefault();
    scroll.scrollTo(330);
    navigate(props.path, { replace: true });
  }

  const [headerPhoto, setHeaderPhoto] = React.useState(null);

  React.useEffect(() => {
    if (props.image) {
      setHeaderPhoto(props.image);
    } else if (props.cmsImage) {
      getImageUrl(props.cmsImage).then((imageUrl) => setHeaderPhoto(imageUrl));
    }
  }, [props.image, props.cmsImage, getImageUrl]);

  // const cutToWords = useCallback((text, numberOfWords) => {
  //   if (!text) return "";
  //   return text.split(" ").slice(0, numberOfWords).join(" ").concat("...");
  // }, []);

  return (
    <Card
      className={cx(cardStyles.root, shadowStyles.root)}
      onClick={(e) => readClicked(e)}
      style={{ margin: 0, marginBottom: "20px", width: "100%" }}
    >
      {headerPhoto && <CardMedia classes={mediaStyles} image={headerPhoto} />}

      <CardContent className={cardStyles.content}>
        <TextInfoContent
          classes={textCardContentStyles}
          heading={props.title}
          // body={cutToWords(props.description, 30)}
        />
      </CardContent>

      <Box px={2} pb={2} mt={-1}>
        {/* <Fab variant="extended" style={{backgroundColor:"#45aec3", color:"white"}}>czytaj</Fab> */}
        <Button
          color="transparent"
          style={{
            border: "2px solid #00acc1",
          }}
          fullWidth={true}
        >
          sprawdź
        </Button>
      </Box>
    </Card>
  );
};

ApartmentCardSmall.propTypes = {
  path: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  cmsImage: PropTypes.string,
};

export default ApartmentCardSmall;
